/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    return this.store.findAll('posts/tag-category');
  }
}
